<mat-form-field appearance="outline">
  <mat-label>Organization</mat-label>
  <input
    #filterInput
    type="text"
    matInput
    id="organizationSelect-filterInput"
    [formControl]="organizationSelect"
    [matAutocomplete]="auto"
    (input)="filter()"
    (focus)="filter()"
    />
  <mat-autocomplete #auto="matAutocomplete" requireSelection [displayWith]="getOrganizationText">
    <mat-option
      *ngFor="let organization of filteredOrganizations"
      id="organizationSelect-matOption-{{ organization.id }}"
      [value]="organization">
      {{ organization.name }} ({{ organization.code }})
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
